/**
 * The axon mark — a neural branching glyph. One input → two venues.
 * Source of truth for the logo: this component (inline SVG paths
 * below). The PNG/SVG favicon copies under `public/` are derived.
 */
export function AxonMark({
  size = 28,
  color,
  className,
}: {
  size?: number;
  color?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color: color ?? "var(--at-accent)" }}
      aria-label="Axon"
    >
      <circle cx="32" cy="14" r="4" fill="currentColor" />
      <path d="M32 18 L32 32" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
      <path d="M32 32 L18 48" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
      <path d="M32 32 L46 48" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
      <rect x="14" y="47" width="8" height="8" fill="currentColor" />
      <rect x="42" y="47" width="8" height="8" fill="currentColor" />
    </svg>
  );
}

/**
 * Lockup: mark + "axon" wordmark side by side.
 * Used in Nav + Hero.
 */
export function AxonLockup({
  size = 28,
  color,
  wordmarkWeight = 700,
}: {
  size?: number;
  color?: string;
  wordmarkWeight?: number;
}) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: Math.round(size * 0.4),
      }}
    >
      <AxonMark size={size} color={color} />
      <span
        style={{
          fontFamily: "Inter, system-ui, sans-serif",
          fontSize: Math.round(size * 0.78),
          fontWeight: wordmarkWeight,
          letterSpacing: "-0.02em",
          color: color ?? "var(--at-fg)",
          lineHeight: 1,
        }}
      >
        axon
      </span>
    </span>
  );
}
